// Gamma-styled status pill badge for SLD detail panel
interface StatusBadgeProps {
  status: string;
  pulse?: boolean;
}

const STATUS_STYLES: Record<string, string> = {
  on: 'bg-ems-green/20 text-ems-green',
  running: 'bg-ems-green/20 text-ems-green',
  online: 'bg-ems-green/20 text-ems-green',
  active: 'bg-ems-green/20 text-ems-green',
  closed: 'bg-ems-green/20 text-ems-green',
  charging: 'bg-ems-blue/20 text-ems-blue',
  discharging: 'bg-ems-cyan/20 text-ems-cyan',
  generating: 'bg-ems-amber/20 text-ems-amber',
  degraded: 'bg-ems-amber/20 text-ems-amber',
  standby: 'bg-ems-text-muted/20 text-ems-text-secondary',
  idle: 'bg-ems-text-muted/20 text-ems-text-secondary',
  off: 'bg-ems-text-muted/20 text-ems-text-muted',
  offline: 'bg-ems-text-muted/20 text-ems-text-muted',
  fault: 'bg-ems-red/20 text-ems-red',
  tripped: 'bg-ems-red/20 text-ems-red',
  open: 'bg-ems-red/20 text-ems-red',
};

function isOnlineStatus(status: string): boolean {
  // 'degraded' IS online — that is the entire point of the tier (djin-cloud#618).
  // Omitting it here dropped the presence dot from an impaired-but-producing
  // asset, so the badge read as offline-ish while the card showed live power.
  return ['on', 'running', 'online', 'active', 'closed', 'charging', 'discharging', 'generating', 'degraded'].includes(status.toLowerCase());
}

function isFaultStatus(status: string): boolean {
  return ['fault', 'tripped'].includes(status.toLowerCase());
}

export function StatusBadge({ status, pulse }: StatusBadgeProps) {
  const normalized = status.toLowerCase();
  const cls = STATUS_STYLES[normalized] ?? 'bg-ems-text-muted/20 text-ems-text-muted';
  const shouldPulse = pulse ?? isFaultStatus(normalized);

  return (
    <span
      className={`inline-flex items-center text-[10px] px-2 py-0.5 rounded-full font-semibold uppercase tracking-wide ${cls} ${shouldPulse ? 'animate-ems-pulse' : ''}`}
    >
      {isOnlineStatus(normalized) && (
        <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 flex-shrink-0" />
      )}
      {status.toUpperCase()}
    </span>
  );
}
